// import React, { useState, useEffect } from "react";
// import { useSearchParams } from "react-router-dom";
// import Table from "react-bootstrap/Table";
// import Button from "react-bootstrap/Button";
// import NavigationBar from "../../Components/NavigationBar";

// export default function McMemberApprove() {
//   const [searchParams] = useSearchParams();
//   const applicationId = searchParams.get("applicationId");
//   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
//   const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL;
//   // Extract the applicationId from the URL

//   const [application, setApplication] = useState(null);

//   // Fetch the specific application from the backend using the applicationId
//   useEffect(() => {
//     if (applicationId) {
//       fetch(`${API_BASE_URL}/getApplicationById/${applicationId}`)
//         .then((response) => response.json())
//         .then((data) => {
//           console.log("Fetched Application:", data);
//           console.log("API Response Data:", data); // Add this line
//           console.log("Actual Status:", data.Status); // And this line
//           if (data) {
//             setApplication(data);
//           } else {
//             console.error("No application found with this ID.");
//           }
//         })
//         .catch((error) => console.error("Error fetching application:", error));
//     }
//   }, [applicationId]);

//   // Approve and Reject actions
//   const updateDecision = async (appId, decision) => {
//     try {
//       const res = await fetch(`${API_BASE_URL}/updateMCMemberDecision`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ app_ID: appId, decision }),
//       });

//       if (res.ok) {
//         alert(`Application ${appId} ${decision.toLowerCase()}!`);
//         setApplication((prev) => ({
//           ...prev,
//           Status: decision === "Approved" ? "3.1" : "3.2",
//         }));
//       } else {
//         const error = await res.json();
//         alert("Failed to update decision: " + error.error);
//       }
//     } catch (err) {
//       console.error("Error:", err);
//       alert("An error occurred while updating decision.");
//     }
//   };

//   const handleApprove = (appId) => updateDecision(appId, "Approved");
//   const handleReject = (appId) => updateDecision(appId, "Rejected");

//   return (
//     <div>
//       <NavigationBar />
//       <h1 className="page-name">Dean Approval (Shortlisted Application)</h1>

//       {application ? (
//         <Table
//           striped
//           bordered
//           hover
//           style={{
//             marginTop: "20px",
//             boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
//           }}
//         >
//           <thead>
//             <tr>
//               <th>Application Id</th>
//               <th>Award Type</th>
//               <th>Submitted Date</th>
//               <th>Status</th>
//               <th>Decision</th>
//               <th>Application</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr key={application.Application_Id}>
//               <td>{application.Application_Id}</td>
//               <td>{application.Award_Type}</td>
//               <td>{application.SubmittedDate}</td>
//               <td>{application.Status}</td>
//               <td>
//                 {application.Status === "Approved" ? ( // Changed from Status to StatusCode
//                   <Button variant="success">Approved</Button>
//                 ) : application.Status === "Rejected" ? (
//                   <Button variant="danger">Rejected</Button>
//                 ) : (
//                   <>
//                     <Button
//                       variant="success"
//                       onClick={() => handleApprove(application.Application_Id)}
//                     >
//                       Approve
//                     </Button>
//                     <Button
//                       variant="danger"
//                       style={{ marginLeft: "10px" }}
//                       onClick={() => handleReject(application.Application_Id)}
//                     >
//                       Reject
//                     </Button>
//                   </>
//                 )}
//               </td>
//               <td>
//                 <Button
//                   variant="info"
//                   onClick={() => {
//                     const formattedAwardType = application.Award_Type.replace(
//                       /\s+/g,
//                       "_"
//                     );
//                     const fileName = `${application.Application_Id}_${formattedAwardType}.pdf`;
//                     const fileUrl = `${FILE_BASE_URL}/ApplicationForms/${fileName}`;
//                     window.open(fileUrl, "_blank"); // ✅ Open in a new tab
//                   }}
//                 >
//                   View
//                 </Button>
//               </td>
//             </tr>
//           </tbody>
//         </Table>
//       ) : (
//         <p>Loading application details...</p>
//       )}
//     </div>
//   );
// }
import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import NavigationBar from "../../Components/NavigationBar";

export default function McMemberApprove() {
  const [searchParams] = useSearchParams();
  const applicationId = searchParams.get("applicationId");
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
  const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL || 'http://localhost:5000/uploads';
  const [application, setApplication] = useState(null);

  // Map numeric status codes to descriptive strings
  const statusMap = {
    "3.1": "Approved",
    "3.2": "Rejected",
  };

  // Fetch the specific application from the backend using the applicationId
  useEffect(() => {
    if (applicationId) {
      fetch(`${API_BASE_URL}/getApplicationById/${applicationId}`)
        .then((response) => response.json())
        .then((data) => {
          console.log("Fetched Application:", data);
          if (data) {
            setApplication({
              ...data,
              Status: statusMap[data.Status] || data.Status,
            });
          } else {
            console.error("No application found with this ID.");
          }
        })
        .catch((error) => console.error("Error fetching application:", error));
    }
  }, [applicationId]);

  // Send email (accept or reject)
  const sendEmail = async (appId, decision, applicantName, applicantEmail, awardType) => {
    if (!applicantEmail) {
      console.error("Cannot send email: applicantEmail is undefined", { appId, applicantName, applicantEmail, awardType });
      alert("Cannot send email: Applicant email is missing.");
      return;
    }

    if (!awardType) {
      console.error("Cannot send email: awardType is undefined", { appId, applicantName, applicantEmail, awardType });
      alert("Cannot send email: Award type is missing.");
      return;
    }

    const name = applicantName || (decision === "Approved" ? "Award Recipient" : "Award Applicant");
    let emailSubject, emailBody;

    if (awardType.includes("Research Excellence")) {
      emailSubject = `Research Excellence Awards`;
      if (decision === "Approved") {
        emailBody = `Dear ${name},\n\nThank you for your application to the Research Excellence Award. I am delighted to inform you that your application (Application ID: ${appId}) has been successful. Congratulations on this well-deserved achievement!\n\nWe will provide further details regarding the date, time, and arrangements for the award ceremony in due course. Should you have any questions in the meantime, please feel free to contact us.\n\nOnce again, congratulations on your outstanding accomplishment.\n\nThis is a system-generated email, and please do not respond to this email.\n\nBest regards,\nDirector/URC`;
      } else {
        emailBody = `Dear ${name},\n\nThank you for submitting your application for the Research Excellence Award (Application ID: ${appId}). We greatly appreciate the time and effort you invested in the application process. I regret to inform you that your application was not successful.\n\nShould you have any questions or wish to receive feedback on your application, please feel free to contact us at secretaryurc@gs.pdn.ac.lk.\n\nThank you again for your interest in the Research Excellence Award.\n\nThis is a system-generated email, and please do not respond to this email.\n\nBest regards,\nDirector/URC`;
      }
    } else {
      console.error("Unknown award type:", awardType);
      alert("Cannot send email: Unknown award type.");
      return;
    }

    try {
      // Send email
      const emailResponse = await fetch(`${API_BASE_URL}/sendEmail`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          to: applicantEmail,
          subject: emailSubject,
          text: emailBody,
          html: `<p>${emailBody.replace(/\n/g, '<br>')}</p>`,
        }),
      });

      // Check if response is JSON
      const contentType = emailResponse.headers.get("content-type");
      let emailData;
      if (contentType && contentType.includes("application/json")) {
        emailData = await emailResponse.json();
      } else {
        emailData = { message: await emailResponse.text() };
      }

           if (!emailResponse.ok) throw new Error(emailData.message || "Failed to send email");

      console.log("Email sent successfully:", emailData.message || "Success");
      alert("Email sent successfully.");
    } catch (error) {
      console.error("Error sending email:", error);
      alert("Failed to send email.");
    }
  };

  // Approve and Reject actions
  const updateDecision = async (appId, decision) => {
    try {
      const res = await fetch(`${API_BASE_URL}/updateMCMemberDecision`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ app_ID: appId, decision }),
      });

      const contentType = res.headers.get("content-type");
      let responseData;
      if (contentType && contentType.includes("application/json")) {
        responseData = await res.json();
      } else {
        responseData = { message: await res.text() };
      }

      if (res.ok) {
        alert(`Application ${appId} ${decision.toLowerCase()}!`);
        setApplication((prev) => ({
          ...prev,
          Status: decision === "Approved" ? "Approved" : "Rejected",
        }));

        // Send email after successful status update
        if (application) {
          await sendEmail(
            appId,
            decision,
            application.Applicant_Name || application.Name,
            application.applicantEmail,
            application.Award_Type
          );
        }
      } else {
        alert("Failed to update decision: " + responseData.message);
      }
    } catch (err) {
      console.error("Error:", err);
      alert("An error occurred while updating decision.");
    }
  };

  const handleApprove = (appId) => updateDecision(appId, "Approved");
  const handleReject = (appId) => updateDecision(appId, "Rejected");

  return (
    <div>
      <NavigationBar />
      <h1 className="page-name">MC Member Approval (Shortlisted Application)</h1>

      {application ? (
        <Table
          striped
          bordered
          hover
          style={{
            marginTop: "20px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
          }}
        >
          <thead>
            <tr>
              <th>Application Id</th>
              <th>Award Type</th>
              <th>Submitted Date</th>
              <th>Status</th>
              <th>Decision</th>
              <th>Application</th>
            </tr>
          </thead>
          <tbody>
            <tr key={application.Application_Id}>
              <td>{application.Application_Id}</td>
              <td>{application.Award_Type}</td>
              <td>{application.SubmittedDate}</td>
              <td>{application.Status}</td>
              <td>
                {application.Status === "Approved" ? (
                  <Button variant="success" disabled>
                    Approved
                  </Button>
                ) : application.Status === "Rejected" ? (
                  <Button variant="danger" disabled>
                    Rejected
                  </Button>
                ) : (
                  <>
                    <Button
                      variant="success"
                      onClick={() => handleApprove(application.Application_Id)}
                    >
                      Approve
                    </Button>
                    <Button
                      variant="danger"
                      style={{ marginLeft: "10px" }}
                      onClick={() => handleReject(application.Application_Id)}
                    >
                      Reject
                    </Button>
                  </>
                )}
              </td>
              <td>
                <Button
                  variant="info"
                  onClick={() => {
                    const formattedAwardType = application.Award_Type.replace(
                      /\s+/g,
                      "_"
                    );
                    const fileName = `${application.Application_Id}_${formattedAwardType}.pdf`;
                    const fileUrl = `${FILE_BASE_URL}/api/Uploads/ApplicationForms/${fileName}`;
                    window.open(fileUrl, "_blank");
                  }}
                >
                  View
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>
      ) : (
        <p>Loading application details...</p>
      )}
    </div>
  );
}